<template>
    <div>
        <div class="bg-white pt-10 pb-10">
            <v-container>
                <v-row>
                    <v-col cols="12" lg="5">
                        <img
                            :src="require('@/assets/images/htp1.png')"
                            width="100%"
                        />
                    </v-col>

                    <v-col
                        cols="12"
                        lg="7"
                        :class="display.mdAndUp.value ? 'pl-7' : ''"
                    >
                        <div
                            class="font-weight-600 text-inkblue text-center"
                            :class="
                                display.mdAndUp.value
                                    ? 'font-size-28'
                                    : 'font-size-20 line-height-28'
                            "
                        >
                            Tutorial Pembelian Paket Belajar Skolla
                        </div>

                        <div class="mt-7">
                            <div
                                v-for="(tutorial, i) in tutorials"
                                :key="i"
                                class="d-flex align-center gap-20 mb-3"
                            >
                                <v-btn
                                    size="x-small"
                                    class="elevation-0"
                                    icon
                                    color="#0e97d6"
                                    dark
                                >
                                    <span class="font-size-14">
                                        {{ i + 1 }}
                                    </span>
                                </v-btn>
                                <div>
                                    <p
                                        v-html="tutorial"
                                        class="font-size-16 text-blacknew"
                                    ></p>
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </div>

        <div class="bg-lightpurple pdy-70 text-center px-3">
            <div
                class="font-weight-600 text-inkblue"
                :class="
                    display.mdAndUp.value
                        ? 'font-size-28'
                        : 'font-size-20 line-height-24'
                "
            >
                Tutorial Aktivasi Akun Siswa Skolla
            </div>

            <div class="text-blacknew font-size-16 mt-2">
                Pastikan Anda sudah memiliki Kode Aktivasi untuk melakukan
                aktivasi akun Skolla.
            </div>

            <div class="mt-5">
                <div class="stepper">
                    <div v-for="(step, i) in steps" :key="i" class="step">
                        <div class="circle">
                            {{ i + 1 }}
                        </div>
                        <div class="line"></div>
                        <div class="content">
                            <div
                                class="font-weight-600 font-size-16 text-blacknew"
                            >
                                {{ step.title }}
                            </div>

                            <div
                                class="mt-3 font-weight-300 font-size-14 text-blacknew"
                                v-html="step.subtitle"
                            ></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="bg-lightblue pdy-50 text-center px-3">
            <v-container>
                <div
                    class="font-weight-600 text-inkblue"
                    :class="
                        display.mdAndUp.value
                            ? 'font-size-28'
                            : 'font-size-20 line-height-24'
                    "
                >
                    Syarat dan Ketentuan Skema Cicilan
                </div>

                <div class="mt-10 pb-4">
                    <v-row>
                        <v-col cols="12" lg="6">
                            <v-card class="elevation-0 rounded-20 fullheight">
                                <v-card-text class="pa-7 fullheight">
                                    <div class="d-flex align-center gap-10">
                                        <v-btn
                                            size="x-small"
                                            class="elevation-0 p-0"
                                            icon
                                            color="#0e97d6"
                                            dark
                                        >
                                            <span class="font-size-14">
                                                1
                                            </span>
                                        </v-btn>

                                        <div
                                            class="font-weight-600 text-inkblue"
                                            :class="
                                                display.mdAndUp.value
                                                    ? 'font-size-20'
                                                    : 'font-size-18'
                                            "
                                        >
                                            Skema Cicilan
                                        </div>
                                    </div>

                                    <div class="mt-5 text-left px-6">
                                        <ul style="list-style-type: circle">
                                            <li
                                                v-for="(scheme, i) in schemes"
                                                :key="i"
                                                class="mb-3 font-size-16 text-blacknew"
                                            >
                                                {{ scheme }}
                                            </li>
                                        </ul>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" lg="6">
                            <v-card class="elevation-0 rounded-20 fullheight">
                                <v-card-text class="pa-7 fullheight">
                                    <div
                                        class="d-flex align-center gap-10 justify-start"
                                    >
                                        <v-btn
                                            size="x-small"
                                            class="elevation-0 p-0"
                                            icon
                                            color="#0e97d6"
                                            dark
                                        >
                                            <span class="font-size-14">
                                                2
                                            </span>
                                        </v-btn>

                                        <div
                                            class="font-weight-600 text-inkblue"
                                            :class="
                                                display.mdAndUp.value
                                                    ? 'font-size-20'
                                                    : 'font-size-18'
                                            "
                                        >
                                            Ketentuan Pelunasan
                                        </div>
                                    </div>

                                    <div class="mt-5 text-left px-6">
                                        <ul style="list-style-type: circle">
                                            <li
                                                v-for="(
                                                    data, i
                                                ) in settlements1"
                                                :key="i"
                                                class="mb-3 font-size-16 text-blacknew"
                                            >
                                                {{ data }}
                                            </li>
                                        </ul>
                                    </div>

                                    <div
                                        class="text-left pl-2 font-size-16 font-weight-600"
                                    >
                                        Jika melebihi batas waktu pelunasan,
                                        maka
                                    </div>

                                    <div class="text-left px-6">
                                        <ul style="list-style-type: circle">
                                            <li
                                                v-for="(
                                                    data, i
                                                ) in settlements2"
                                                :key="i"
                                                class="mt-2 font-size-16 text-blacknew"
                                            >
                                                {{ data }}
                                            </li>
                                        </ul>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </div>
            </v-container>
        </div>

        <div class="bg-skyblue pdy-50 text-center px-3">
            <v-container>
                <div class="d-flex align-center justify-center gap-30">
                    <div v-if="display.lgAndUp.value">
                        <img :src="require('@/assets/images/answer.svg')" />
                    </div>

                    <div
                        class="font-weight-600 text-inkblue"
                        :class="
                            display.mdAndUp.value
                                ? 'font-size-28'
                                : 'font-size-20 line-height-24'
                        "
                    >
                        Pertanyaan Yang Sering Diajukan
                    </div>

                    <div v-if="display.lgAndUp.value">
                        <img :src="require('@/assets/images/ask.svg')" />
                    </div>
                </div>

                <div class="mt-10 pb-4">
                    <v-expansion-panels
                        variant="accordion"
                        class="border-1 rounded-15 mb-6"
                        v-model="panel1"
                    >
                        <v-expansion-panel active class="rounded-15">
                            <v-expansion-panel-title>
                                <div
                                    class="font-weight-600 py-2 text-inkblue line-height-23"
                                >
                                    Bagaimana jika pembayaran melebihi waktu
                                    jatuh tempo saat harga paket lebih murah
                                    (promo)?
                                </div>
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <div class="text-left text-blacknew pt-3 pb-1">
                                    Jika terjadi perubahan harga (misalnya promo
                                    baru yang lebih murah), harga tetap mengacu
                                    pada perjanjian awal saat pembayaran pertama
                                    dilakukan. Promo baru tidak berlaku untuk
                                    pembayaran lanjutan/cicilan kedua.
                                </div>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>

                    <v-expansion-panels
                        variant="accordion"
                        class="border-1 rounded-15 mb-6"
                        v-model="panel2"
                    >
                        <v-expansion-panel active class="rounded-15">
                            <v-expansion-panel-title>
                                <div
                                    class="font-weight-600 py-2 text-inkblue line-height-23"
                                >
                                    Bagaimana status siswa selama masa jatuh
                                    tempo hingga pelunasan?
                                </div>
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <div
                                    class="text-left text-blacknew pt-1 pb-1 px-5"
                                >
                                    <ul>
                                        <li class="mb-1">
                                            Siswa tetap bisa mengakses paket
                                            belajar secara penuh selama 1 bulan
                                            pertama.
                                        </li>
                                        <li class="mb-1">
                                            Setelah masa 1 bulan, jika belum
                                            melunasi, maka:
                                        </li>
                                    </ul>
                                    <div class="pl-5">
                                        <ul>
                                            <li class="mb-1">
                                                Akses akan dibatasi atau
                                                dinonaktifkan sementara hingga
                                                pelunasan dilakukan.
                                            </li>
                                            <li class="mb-1">
                                                Siswa akan mendapat
                                                pemberitahuan sebelum
                                                dinonaktifkan.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>

                    <v-expansion-panels
                        variant="accordion"
                        class="border-1 rounded-15 mb-6"
                        v-model="panel3"
                    >
                        <v-expansion-panel active class="rounded-15">
                            <v-expansion-panel-title>
                                <div
                                    class="font-weight-600 py-2 text-inkblue line-height-23"
                                >
                                    Apakah bisa mengajukan pengembalian dana?
                                </div>
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <div class="text-left text-blacknew pt-3 pb-1">
                                    Cicilan tidak dapat dikembalikan dan
                                    pengajuan refund tidak berlaku.
                                </div>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>

                    <v-expansion-panels
                        variant="accordion"
                        class="border-1 rounded-15 mb-6"
                        v-model="panel3"
                    >
                        <v-expansion-panel active class="rounded-15">
                            <v-expansion-panel-title>
                                <div
                                    class="font-weight-600 py-2 text-inkblue line-height-23"
                                >
                                    Kapan skema cicilan bisa dilakukan? Paket
                                    apa saja yang bisa dicicil?
                                </div>
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <div class="text-left text-blacknew pt-3 pb-1">
                                    Cicilan berlaku untuk Paket Belajar dengan
                                    durasi 12 bulan, 9 bulan, dan 6 bulan serta
                                    tidak berlaku untuk pembelian fitur satuan*.
                                </div>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </div>
            </v-container>
        </div>
    </div>
</template>

<script>
export default {
    inject: ['display'],
    data() {
        return {
            tutorials: [
                'Buka website https://paket.skolla.online, lalu masuk ke halaman Paket Belajar.',
                'Pilih jenis paket belajar yang Anda inginkan.',
                'Klik <b>“Beli Paket”</b> untuk langsung melakukan pembelian.',
                'Isi identitas pembeli dengan lengkap dan sesuai.',
                'Klik <b>Buat Pesanan”</b> setelah Anda mengisi identitas dan dapatkan invoice melalui email.',
                'Pilih metode pembayaran yang sesuai dan selesaikan.',
                'Setelah pembayaran diverifikasi, Anda akan mendapatkan Kode Aktivasi melalui WhatsApp.',
            ],
            steps: [
                {
                    title: 'Unduh aplikasi Skolla',
                    subtitle:
                        'Unduh aplikasi Skolla di Android (Play Store), iOS (App Store), atau buka versi web di<br/>https://app.skolla.online.',
                },

                {
                    title: 'Daftar akun dan login',
                    subtitle: 'Daftar dengan email/Google, lalu login.',
                },
                {
                    title: 'Masuk menu "Beli Paket"',
                    subtitle:
                        'Setelah login, masuk ke menu <b>“Beli Paket”</b>, klik <b>“Aktivasi”</b>, dan pilih tab <b>“Umum”</b>.',
                },
                {
                    title: 'Masukkan Kode Aktivasi',
                    subtitle: 'Masukkan <b>Kode Aktivasi</b> yang Anda miliki.',
                },
                {
                    title: 'Klik tombol Aktifkan',
                    subtitle:
                        'Klik tombol <b>Aktifkan</b>. Selesai! Profil akun siswa Anda telah aktif. ',
                },
            ],

            schemes: [
                'Skema cicilan hanya berlaku untuk 2x pembayaran, dengan rincian: 50% pembayaran pertama (saat pendaftaran) dan 50% pelunasan maksimal 30 hari setelah pembayaran pertama.',
                'Paket belajar akan aktif selama 1 bulan sejak pembayaran pertama dilakukan.',
            ],
            settlements1: [
                'Pelunasan wajib dilakukan maksimal 7 hari setelah tanggal jatuh tempo.',
            ],
            settlements2: [
                'Paket akan otomatis dinonaktifkan.',
                'Diskon akan hangus dan harga akan disesuaikan ke harga normal.',
            ],
            panel1: [0],
            panel2: [0],
            panel3: [0],
            panel4: [0],
        };
    },
};
</script>

<style scoped>
.stepper {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    max-width: 1200px;
    margin: auto;
    padding-top: 40px;
    position: relative;
}

.step {
    flex: 1;
    text-align: center;
    position: relative;
}

.circle {
    width: 30px;
    height: 30px;
    border-radius: 50px;
    background: #0e97d6;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    font-weight: bold;
    z-index: 2;
    position: relative;
}

.line {
    position: absolute;
    top: 15px;
    left: 50%;
    width: 100%;
    height: 3px;
    background: #b2e3f7;
    z-index: 1;
}

.step:last-child .line {
    display: none;
}

.content {
    margin-top: 10px;
    font-size: 14px;
    color: #333;
    max-width: 250px;
    margin-left: auto;
    margin-right: auto;
    padding: 0px 15px;
}

@media (max-width: 980px) {
    .stepper {
        flex-direction: column;
        align-items: flex-start;
        padding: 0px 10px;
        padding-top: 40px;
    }

    .step {
        display: flex;
        align-items: flex-start;
        text-align: left;
        margin-bottom: 20px;
    }

    .circle {
        min-width: 32px; /* fix biar bulat */
        min-height: 32px; /* fix biar bulat */
        width: 32px;
        height: 32px;
        flex-shrink: 0; /* jangan mengecil */
        margin: 0;
    }

    .line {
        position: absolute;
        top: 30px;
        left: 15px;
        width: 3px;
        height: 100%;
    }

    .content {
        margin-left: 15px;
        margin-top: 0;
        max-width: none;
    }
}
</style>
